import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

const CATEGORIES = ["Action", "Reaction", "Phrase", "Modifier", "Personality", "Feeling", "Noun", "Acronym", "General"];

export default function Submit() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ word: "", meaning: "", example: "", category: "General" });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setSubmitting(true);
    try {
      await api.post("/submissions", form);
      toast.success("Submitted to the think tank. We'll vet it.");
      navigate("/my-submissions");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Could not submit");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-8 py-12">
      <h1 className="font-display text-5xl tracking-tighter mb-2">drop a new word<span className="text-hot">.</span></h1>
      <p className="font-mono-tag text-xs uppercase mb-6">our AI screens it · then a human admin says yay or nay</p>

      <form onSubmit={onSubmit} className="bg-peach brutal p-6 space-y-4">
        <div>
          <label className="font-mono-tag text-[10px] uppercase block mb-1">word</label>
          <input data-testid="submit-word-input" value={form.word} onChange={(e) => update("word", e.target.value)} required maxLength={40}
            placeholder="e.g. Skibidi" className="w-full px-3 py-2 brutal-sm bg-white focus:outline-none font-display text-lg" />
        </div>
        <div>
          <label className="font-mono-tag text-[10px] uppercase block mb-1">meaning</label>
          <textarea data-testid="submit-meaning-input" value={form.meaning} onChange={(e) => update("meaning", e.target.value)} required minLength={3} maxLength={500} rows={3}
            placeholder="What does it actually mean?" className="w-full px-3 py-2 brutal-sm bg-white focus:outline-none" />
        </div>
        <div>
          <label className="font-mono-tag text-[10px] uppercase block mb-1">example sentence</label>
          <textarea data-testid="submit-example-input" value={form.example} onChange={(e) => update("example", e.target.value)} rows={2} maxLength={500}
            placeholder='e.g. "that fit is so skibidi"' className="w-full px-3 py-2 brutal-sm bg-white focus:outline-none" />
        </div>
        <div>
          <label className="font-mono-tag text-[10px] uppercase block mb-1">category</label>
          <select data-testid="submit-category-select" value={form.category} onChange={(e) => update("category", e.target.value)}
            className="w-full px-3 py-2 brutal-sm bg-white focus:outline-none font-display">
            {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>

        {error && <p data-testid="submit-error" className="bg-hot text-white brutal-sm px-3 py-2 font-mono-tag text-xs uppercase">{error}</p>}

        <button data-testid="submit-word-btn" type="submit" disabled={submitting}
          className="w-full bg-hot text-white font-display uppercase py-3 brutal-sm brutal-hover brutal-active disabled:opacity-60">
          {submitting ? "screening with AI..." : "submit for review"}
        </button>
      </form>
    </div>
  );
}
